import { createSerializer } from "nuqs";

import { dispatchParsers, teleopParsers } from "./parsers";

// SERIALIZERS
export const dispatchSerializer = createSerializer(dispatchParsers);
export const teleopSerializer = createSerializer(teleopParsers);
